import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../../Store/Actions'
import useReactRouter from 'use-react-router';
import MaterialTable from 'material-table';
import axios from '../../../Helpers/Axiosbase'
import { LinearProgress ,Snackbar} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

export default function ComponentsList() {
    // Material Table Configuration
    const [columns] = React.useState([
        { title: "Display Name", field: "displayName" },
        { title: "Component Context Code", field: "componentContextCode" },
        { title: "Is Active?", field: "isActive", type: "boolean" },
        { title: "Created On", field: "createDate", type: "date" }
    ]);

    // Setting up States
    const [state, setState] = React.useState({
        showProgress: true,
        componentsData: []
    });

    //Hooks Setup
    const reduxAuth = useSelector((state) => state.auth)
    const { history } = useReactRouter();
    const dispatch = useDispatch();

    const [errorMessage,setErrorMessage]=React.useState({
        open:false,
        errmsg:null,
      });
      const [deleteInfoMsg,setDeleteInfoMsg] = React.useState({
        open:false,
        infoMsg:''
    })

    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setDeleteInfoMsg({
        open:false,
        infoMsg:''
    })
    };

      const handleDeleteComponent = (rowData) =>{
        let url = "componentDelete"
        let postdata = { _id:rowData._id, token: reduxAuth.token, userId: reduxAuth.userId }
        axios.post(url, postdata)
            .then(response => {
              setDeleteInfoMsg({
                open:true,
                infoMsg:'Component Deleted Successfully!!'
            })
                getAllComponent();
                // setState({ showProgress: false, userData: response.data.response });
            })
            .catch(err => {
                if(typeof err.response!="object")
              {
                setErrorMessage({
                  open:true,
                  // errmsg:err
                })
                console.log(err);
              }
              else 
              {
                if (err.response.status === 403) {
                    // setState({ showProgress: false, userData: [] });
                    dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
                }
              }
        });
    } 

    const getAllComponent=()=>{
      let url = "getAll"
        let postdata = { objectName: "component", token: reduxAuth.token, userId: reduxAuth.userId }
        axios.post(url, postdata)
            .then(response => {
                setState({ showProgress: false, componentsData: response.data.response });
            })
            .catch(err => {
                if(typeof err.response!="object")
              {
                setErrorMessage({
                  open:true,
                  // errmsg:err
                })
                console.log(err);
              }
              else 
              {
                if (err.response.status === 403) {
                    setState({ showProgress: false, componentsData: [] });
                    dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
                }
              }
            });
    }

    useEffect(() => {
        getAllComponent();
    }, []);

    //Render Method
    return (
        <div>
           <Snackbar
                open={deleteInfoMsg.open} autoHideDuration={4000} anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                onClose={handleClose}>
                    <Alert 
                    severity="info"
                    color="info"
                    variant="outlined">
                    {deleteInfoMsg.infoMsg}
                    </Alert>
            </Snackbar>
            <Snackbar
                open={errorMessage.open} autoHideDuration={3000} anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                onClose={handleClose}>
                    <Alert 
                    severity="error"
                    color="error"
                    variant="filled">
                    {errorMessage.errmsg!=null?errorMessage.errmsg:" NetWork Error:Please Check Your Internet Connection"}
                    </Alert>
            </Snackbar>
            {state.showProgress ? <LinearProgress /> : null}
            <MaterialTable
                title="Components"
                columns={columns}
                data={state.componentsData}
                editable={{
                  onRowDelete: oldData =>
                  new Promise(resolve => {
                    setTimeout(() => {
                      resolve();
                      handleDeleteComponent(oldData);
                    }, 600);
                  }),
                }}
                actions={[
                    {
                        icon: 'edit',
                        tooltip: 'Edit Component',
                        onClick: (event, rowData) => {
                            history.push('/components/manage', rowData);
                        }
                    },
                    {
                        icon: 'add',
                        tooltip: 'Add Component',
                        isFreeAction: true,
                        onClick: (event) => history.push("/components/manage")
                    },
                ]}
            />
        </div>
    );
}